<article class="melding">
    <html-formatert [innhold]="melding().melding"></html-formatert>

    <div class="handlinger">
        <button class="primær" type="button" (click)="opprettFraMal.emit(melding())">
            {{ 'Opprett ny basert på denne' | translate }}
        </button>
        <button class="advarsel" type="button" (click)="slettMelding()">
            <span class="ion-ios-trash" aria-hidden="true"></span>
            {{ 'Slett melding' | translate }}
        </button>
        <div class="metainfo">
          <span>varseltype:</span> {{ varseltype() }}
          <span>{{ 'Gyldig til' | translate }}:</span>
            @if (melding().gyldigTil) {
                {{ melding().gyldigTil | zoneddatetime:'short' }}
            } @else {
                –
            }
            <span>{{ 'Type' | translate }}:</span> {{ meldingstype(melding().meldingstype) }}
        </div>
    </div>
</article>
